const PaymentCardGroupIcon = props => (
	<svg viewBox="0 0 15 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M5.42826 9.31428C5.73638 9.31428 6.0445 9.06778 6.0445 8.69803C6.0445 8.38991 5.79801 8.08179 5.42826 8.08179C5.12013 8.08179 4.81201 8.32829 4.81201 8.69803C4.87364 9.00616 5.12013 9.31428 5.42826 9.31428Z"
			fill="black"
		/>
		<path
			d="M5.42848 9.74563C4.87386 9.74563 4.38086 9.31426 4.38086 8.69801C4.38086 8.14339 4.81223 7.65039 5.42848 7.65039C6.04473 7.65039 6.4761 8.08176 6.4761 8.69801C6.4761 9.25263 6.04473 9.74563 5.42848 9.74563ZM5.42848 8.57476C5.36685 8.57476 5.30523 8.63639 5.30523 8.69801C5.30523 8.82126 5.36685 8.82126 5.42848 8.82126C5.55173 8.82126 5.55173 8.75963 5.55173 8.69801C5.61335 8.63639 5.55173 8.57476 5.42848 8.57476Z"
			fill="black"
		/>
		<path
			d="M13.9326 12.1491H2.84018C2.40881 12.1491 2.03906 11.7794 2.03906 11.348V3.76816C2.03906 3.33679 2.40881 2.96704 2.84018 2.96704H13.9326C14.364 2.96704 14.7337 3.33679 14.7337 3.76816V11.348C14.7337 11.7794 14.364 12.1491 13.9326 12.1491ZM2.90181 11.2247H13.871V6.17152H2.90181V11.2247ZM2.90181 5.30878H13.871V3.82979H2.90181V5.30878Z"
			fill="black"
		/>
		<path
			d="M13.9326 12.1491H2.84018C2.40881 12.1491 2.03906 11.7794 2.03906 11.348V3.76816C2.03906 3.33679 2.40881 2.96704 2.84018 2.96704H13.9326C14.364 2.96704 14.7337 3.33679 14.7337 3.76816V11.348C14.7337 11.7794 14.364 12.1491 13.9326 12.1491ZM2.90181 11.2247H13.871V6.17152H2.90181V11.2247ZM2.90181 5.30878H13.871V3.82979H2.90181V5.30878Z"
			fill="black"
		/>
		<path
			d="M12.4534 0.93335H0.559892C0.251768 0.93335 0.0668945 1.17985 0.0668945 1.42635V9.43755C0.0668945 9.74568 0.313393 9.93055 0.559892 9.93055C0.80639 9.93055 1.05289 9.68405 1.05289 9.43755V1.98097H12.4534C12.7616 1.98097 12.9464 1.73447 12.9464 1.48797C12.9464 1.24147 12.7616 0.93335 12.4534 0.93335Z"
			fill="black"
		/>
	</svg>
);
export default PaymentCardGroupIcon;
